import { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import {
  IconBrandWhatsapp,
  IconDeviceMobileMessage,
} from "@tabler/icons-react";
import "../PhoneForm.scss";
import { useStep } from "usehooks-ts";
import PhoneSelector from "../../../../../../components/Controls/PhoneSelector/PhoneSelector";
import Button from "../../../../../../components/form/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCustomerProfile } from "../../../../../Account/EditProfile/hooks/useProfile";
import { CustomerData } from "../../../../../../models/authUserModel";

interface PhoneFormData {
  phone: string;
  area_code: string;
  otp_option?: string;
}
interface StepOnePhoneData {
  helpers: any;
  customerInfo?: CustomerData;
}


const PhoneStepOne = ({ helpers, customerInfo }: StepOnePhoneData) => {
  const [dialCode, setDialCode] = useState("");
  const [phoneLength, setPhoneLength] = useState(0);
  const { goToNextStep } = helpers;
  const {
    editPhoneData,
    errorMessage,
    errorMessageText,
    successMessageText,
    successMessage,
  } = useCustomerProfile();
  const schema = yup.object({
  phone: yup
    .string()
    .test(
      "phone-required-if-area-invalid",
      "Debes ingresar un número válido",
      function (value) {
        // Acceso correcto al dialCode desde el closure
        if (dialCode === "-" || dialCode === "-1") {
          return Boolean(value && value.length > 0);
        }
        return true;
      }
    )
    .length(phoneLength, `Debe contener exactamente ${phoneLength} dígitos`)
    .required("El número de teléfono es requerido"),

  otp_option: yup
    .string()
    .required("Debes seleccionar el medio por el que quieres recibir tu código"),
});

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm<PhoneFormData>({
  resolver: yupResolver(schema),
});

  useEffect(() => {
    setValue("otp_option", "whatsapp");
  }, []);

  useEffect(() => {
  if (customerInfo?.phone && (customerInfo?.area_code !== "-" && customerInfo?.area_code !== "-1")) {
    setValue("phone", customerInfo.phone);
  } else {
    setValue("phone", "");
  }
}, [customerInfo]);



  const handleSendPhone = async (props: PhoneFormData) => {
    const { otp_option, ...cleanProps } = props;

    const addedData = {
      ...cleanProps,
      area_code: dialCode,
    };

    await editPhoneData(addedData, goToNextStep, props?.otp_option as string);
  };

  return (
    <Fragment>
      {successMessage && (
        <div
          className="bg-[#E7F8EF] rounded-xl font-medium py-2 px-6 text-[#0E7C3A] mb-3"
          role="alert"
        >
          <p className=" text-sm">{successMessageText}</p>
        </div>
      )}
      {errorMessage && (
        <div
          className="bg-[#FEE2E2] rounded-xl font-medium py-2 px-6 text-[#B91C1C] mb-3"
          role="alert"
        >
          <p className=" text-sm">{errorMessageText}</p>
        </div>
      )}

      {
        (customerInfo?.area_code !== "-" && customerInfo?.area_code !== "-1") && (
          <div className="bg-[#FFF7E6] border border-[#F7D08A] text-[#8A5A00] text-sm px-4 py-2 rounded-lg mt-2">
   <p>Ya tienes un número verificado 
    ({customerInfo?.area_code} {customerInfo?.phone}).  
    Si deseas cambiarlo, deberás completar nuevamente el proceso de validación.</p> 
  </div>
        )
      }
      
      <form onSubmit={handleSubmit(handleSendPhone)}>
        <div className="w-full">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4">
            <div>
              <label className="w-full md:w-1/4 text-gray-700 font-bold text-base">
                Número de telefono
              </label>
              <p className=" text-xs font-light text-[#757575]">
                Necesitamos validar tus datos
              </p>
            </div>
            <div className="md:w-3/4">
             <PhoneSelector
                name="phone"
                control={control}
                onCountryCodeChange={(code) => {
                  setDialCode(code);
                  if (code === "-" || code === "-1") {
                    setValue("phone", "");
                  }
                }}
                onCountryLengthChange={(length) => setPhoneLength(length)}
                defaultCode={customerInfo?.area_code}
                defaultPhone={
                    customerInfo?.area_code === "-" || customerInfo?.area_code === "-1"
                      ? ""
                      : customerInfo?.phone
                  }
              />

              <p className=" text-sm font-semibold text-red text-left mt-2">
                {errors?.phone?.message}
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between md:gap-4 mt-6">
            <div>
              <label
                htmlFor=""
                className="w-full md:w-1/4 text-gray-700 font-bold text-base"
              >
                Verificar número de teléfono
              </label>
              <p className=" text-xs font-light text-[#757575]">
                Se te enviarará un código de verificación
              </p>
            </div>
            <div className="w-full md:w-3/4">
              <div className="grid grid-cols-2 lg:grid-cols-3 relative">
                <label className="label-otp mt-2">
                  <input
                    {...register("otp_option")}
                    type="radio"
                    value="whatsapp"
                  />
                  <span className="text-sm text-[#757575]">
                    Whatsapp <IconBrandWhatsapp className="ml-2" stroke={2} />
                  </span>
                </label>
                {dialCode !== "+1" && (
                  <label className="label-otp">
                    <input
                      {...register("otp_option")}
                      type="radio"
                      value="sms"
                    />
                    <span className="text-sm text-[#757575]">
                      Mensaje de texto{" "}
                      <IconDeviceMobileMessage className="ml-2" stroke={2} />
                    </span>
                  </label>
                )}
              </div>
              <p className=" text-sm font-medium text-red text-left">
                {errors?.otp_option &&
                  "Selecciona una opción para verificar tu número"}
              </p>
            </div>

            {/* {errors?.type_id?.message && (
              <p className=" text-xs font-normal text-red mt-1 text-center">
                {errors?.type_id?.message}
              </p>
            )} */}
          </div>
          <Button
            type="submit"
            className="w-full lg:w-auto mt-8 ml-auto font-semibold py-3 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
          >
            Guardar número de teléfono
          </Button>
        </div>
      </form>
    </Fragment>
  );
};
export default PhoneStepOne;
